import { render } from "./ProductSubsix.vue?vue&type=template&id=18648698&scoped=true"
import script from "./ProductSubsix.vue?vue&type=script&lang=js"
export * from "./ProductSubsix.vue?vue&type=script&lang=js"

import "./ProductSubsix.vue?vue&type=style&index=0&id=18648698&scoped=true&lang=css"
import "./ProductSubsix.vue?vue&type=style&index=1&id=18648698&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18648698"]])

export default __exports__